import Vue from 'vue'
import router from './routes/index';
import store from './store/index';

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import Vuex from 'vuex'
Vue.use(Vuex)

import App from './App.vue'
import pagetitle from './layout/pagetitle.vue'
Vue.component('pagetitle', pagetitle)

import "./css/playworld.css"

Vue.config.productionTip = false

Vue.mixin({
  	methods: {
  		checkUserHasPermission(name){
  			let output = false;
  			let permissions = this.$store.state.user.allPermissions;
  			if(permissions.length > 0){
				permissions.forEach(function(permission) {
					if(permission.name.toLowerCase() == name.toLowerCase()){
						output = true;
					}
				});
			}
			return output;
  		},
  		checkUserHasRole(name){
  			let output = false;
  			let roles = this.$store.state.user.roles;
  			if(roles.length > 0){
				roles.forEach(function(role) {
					if(role.name.toLowerCase() == name.toLowerCase()){
						output = true;
					}
				});
			}
			return output;
  		},
  		hasProp (obj, prop) {
			return Object.prototype.hasOwnProperty.call(obj, prop);
		},
		getToday(){
			console.log();
			return new Date().getFullYear() + '-'+ ('0'+ (new Date().getMonth() + 1)).slice('-2')+'-'+('0'+new Date().getDate()).slice('-2');
		},
		showErrormessage(msg){
			// alert(msg);
			this.$store.commit('setNotification',msg);
		}
  	}
});
// localStorage.removeItem('token');
// localStorage.removeItem('user');

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// import VueRouter from 'vue-router'
// Vue.use(VueRouter)